/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React from "react";
import PropTypes from "prop-types";
import "./style.less";
import axios from "axios";
import Request from "../../utils/request";
import utils from "../../utils/utils";
import moment from 'moment';
const bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 375;
const voteStorageName = 'h5_localStorageVoteListMessage'
const curDate = moment(new Date().getTime()).format('YYYY/MM/DD')
class PipelineImgList extends React.Component {
  constructor(props) {
    super(props);
    const { showType, imgType = {}, textType = {} } = props.config.contentConfig;
    this.state = {
      has_vote: false,
      vote_ids: [],
      visible: !utils.isShihuo(),
      //以下仅支持 图片形式投票
      can_vote: 0,//是否可投票: 0 不可，1 可
      optionList: showType === '图片形式' ? imgType.optionList : textType,
    };
    this.voting = false
    this.pageId = ''
    this.localVoteList = [];//本地存储的投票列表
    this.curVoteData = {};

  }

  componentDidMount() {
    if (window && window.location.host === 'zt-public.shihuo.cn') {
      const arr = window.location.pathname.split('/')
      this.pageId = arr[arr.length - 2]
    }

    const { contentConfig } = this.props.config;
    // 转为数字处理，后续参与计算
    const isTextType = !contentConfig || contentConfig.showType == '文案形式'
    if (isTextType) {
      this.getVoteResult()
    } else {
      this.getLocalStorage()
    }
  }

  dealTime() {
    const { contentConfig = {} } = this.props.config;
    const { imgType = {} } = contentConfig || {}
    let { startTime, endTime } = imgType || {}
    if(!startTime || !endTime) return {}
    let startTimeStamp = null, endTimeStamp = null;
    startTime = startTime.replace('T', ' ')
    endTime = endTime.replace('T', ' ')

    startTimeStamp = Math.floor(new Date(startTime.replace(/-/g, '/')).getTime() / 1000);
    endTimeStamp = Math.floor(new Date(endTime.replace(/-/g, '/')).getTime() / 1000);

    const now = Math.floor(new Date().getTime() / 1000)
    let time = { now, start_ts: startTimeStamp, end_ts: endTimeStamp }
    if (startTime && endTime && now >= startTimeStamp && now <= endTimeStamp) {
      time.can_vote = 1
    } else if (startTime && now < startTimeStamp) {
      time.can_vote = 2
    }  else if (endTime && now > endTimeStamp) {
      time.can_vote = 3
    } else {
      time.can_vote = 4
    }
    return time
  }
  getVoteResult = () => {
    let waitPromise = null;
    const options = {
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote?access_token=znSnA7pxO35wtPBaur',
      method: 'get',
      withCredentials: true,
      params: {
        special_id: this.pageId,
        vote_name: this.props.customAttributes["data-component-id"],
      },
    }
    if (utils.isAndroid()) {
      waitPromise = axios(options);
    } else {
      waitPromise = Request(options);
    }
    waitPromise.then(res => {
      this.voting = false
      res = res.data
      if (res.status == 0) {
        const { has_vote, vote_id = [], count = {} } = res.data || {}
        this.setState({
          visible: true
        })
        if (!has_vote) {
          return
        }
        const { list = [] } = count
        const { contentConfig = {} } = this.props.config;
        const { textType = {} } = contentConfig || {}
        const { optionList = [] } = textType || {}
        optionList && optionList.forEach((option, index) => {
          let cnt = 0
          list.forEach((item) => {
            if (index == item.vote_id) {
              cnt = item.cnt
            }
          })
          option.cnt = cnt
        })
        this.setState({
          has_vote,
          vote_ids: vote_id
        })
      }
    })
  }

  select = (item, vote_id) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        props: this.props,
      })
      return
    }

    let { has_vote, vote_ids } = this.state
    if (has_vote) {
      return
    }
    if (this.voting) {
      return
    }
    const { contentConfig } = this.props.config;
    const { textType = {} } = contentConfig || {}
    const { mode } = textType
    const index = vote_ids.indexOf(vote_id)
    if (mode == '单选') {
      vote_ids = [vote_id]
    } else {
      if (index >= 0) {
        vote_ids.splice(index, 1)
      } else {
        vote_ids.push(vote_id)
      }
    }
    this.setState({
      vote_ids
    })
  }

  vote = () => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        props: this.props,
      })
      return
    }

    utils.uploadTrack(this.props);

    const { has_vote, vote_ids } = this.state
    if (has_vote) {
      return
    }
    if (this.voting) {
      return
    }
    if (vote_ids.length == 0) {
      return
    }
    this.voting = true

    const options = {
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote?access_token=znSnA7pxO35wtPBaur',
      method: 'post',
      withCredentials: true,
      data: {
        special_id: this.pageId,
        vote_id: vote_ids,
        vote_name: this.props.customAttributes["data-component-id"]
      },
    }
    let waitPromise = null;
    if (utils.isAndroid()) {
      waitPromise = axios(options);
    } else {
      waitPromise = Request(options);
    }
    waitPromise.then(res => {
      if (res.data.status === 0) {
        this.getVoteResult()
      } else {
        this.voting = false
      }
    })
  }

  renderTextTypeView() {
    const { has_vote, vote_ids, visible } = this.state
    if (!visible) {
      return null
    }

    let { baseConfig, contentConfig } = this.props.config;
    if(!contentConfig && baseConfig && baseConfig.mode){
      contentConfig = {
        showType: '文案形式',
        question: baseConfig.question,
        textType: {
          optionMargin:  baseConfig.optionMargin,
          textColor: baseConfig.textColor,
          mode: baseConfig.mode,
          optionList: this.props.config.optionList || [],
        },
      }
      this.props.config.contentConfig = contentConfig
    }
    const { moduleMarginTop, moduleMarginHorizon } = baseConfig || {}
    const { textType = {}, question } = contentConfig || {}
    const { optionList = [], textColor, optionMargin, mode } = textType
    // 转为数字处理，后续参与计算

    const isSingle = mode == '单选'
    const maxVoteNumItem = [...(optionList || [])].sort((item1, item2) => {
      return item2.cnt - item1.cnt
    })[0] || {}
    const maxVoteNum = maxVoteNumItem.cnt || 0
    console.log('optionList', optionList);
    return (
      <div
        className="pipeline-vote"
        {...this.props['customAttributes']}
        style={{
          paddingTop: moduleMarginTop >= 0 ? `${moduleMarginTop}px` : 0,
          marginTop: moduleMarginTop < 0 ? `${moduleMarginTop}px` : 0,
        }}
      >
        {question && <div
          className="question"
          style={{ color: textColor }}
        >
          {question}
        </div>}
        <div className="option-block">
          <div
            className="mode"
            style={{ color: textColor }}
          >
            *{isSingle ? '单选' : '可多选'}
          </div>
          <div className="option-list">
            {optionList && optionList.map((item, index) => {
              return (
                <div
                  onClick={this.select.bind(this, item, index)}
                  key={index}
                  className="option"
                  style={{ marginTop: (+optionMargin - 4) + 'px' }}
                >
                  <div className={`radio ${isSingle ? 'single' : ''} ${vote_ids.indexOf(index) >= 0 ? 'selected' : ''}`}></div>
                  <div className="right">
                    <div
                      className="text"
                      style={{ color: textColor }}
                    >
                      {item.option}
                    </div>
                    {
                      has_vote &&
                      <div className="result">
                        <div className="progress-content">
                          {maxVoteNum > 0 && <div className="progress" style={{ width: `${item.cnt * 100 / maxVoteNum}%` }}></div>}
                        </div>
                        <div
                          className="num"
                          style={{ color: textColor }}
                        >
                          {item.cnt}票
                        </div>
                      </div>
                    }
                  </div>
                </div>
              )
            })}
          </div>
          <div
            className={`vote-btn ${has_vote ? 'voted' : ''}`}
            style={{ margin: `${optionMargin}px auto 0 auto` }}
            onClick={this.vote}
          >
            {has_vote ? '已投票' : '投票查看结果'}
          </div>
        </div>
      </div>
    );
  }

  searchCurDataByPageId = () => {
    let curItem = {
      pageId: this.pageId,
      vote_name: this.props.customAttributes["data-component-id"],
      vote_list: [{
        vote_id: [],//对应日期的已投的id
        date: curDate,//投票的日期
        nums: 0,//对应日期的投票的总次数
      }],
      //按活动总周期：仅以 nums总和 作为判断 是否可继续投票的 标准，超出则不可继续投票
      //按日：以 date + nums 作为判断 当天是否可继续投票，当天超出则不可继续投票
    }
    this.localVoteList && this.localVoteList.map(item => {
      if (item.pageId == this.pageId && item.vote_name == this.props.customAttributes["data-component-id"]) {
        curItem = item
      }
    })
    this.curVoteData = curItem;
  }
  getLocalStorage = () => {
    window && window.Jockey.send("localstorage", { type: "get", data: { key: voteStorageName } }, (data) => {
      this.localVoteList = data && data[voteStorageName] ? JSON.parse(data[voteStorageName]) : []
      // alert(JSON.stringify(this.localVoteList))
      this.searchCurDataByPageId()
    });
    const { contentConfig = {} } = this.props.config;
    const { imgType = {} } = contentConfig || {}
    const { optionList = [], type, nums } = imgType || {}
    const time = this.dealTime() || {}
    const { start_ts, end_ts } = time
    const options = {
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote/count/v1?access_token=znSnA7pxO35wtPBaur',
      method: 'get',
      withCredentials: true,
      params: {
        special_id: this.pageId,
        vote_name: this.props.customAttributes["data-component-id"],
        vote_type: type == '按活动总周期' ? 1 : 2,
        limit: nums,
        start_ts, 
        end_ts
      },
    }
    let waitPromise = null;
    if (utils.isAndroid()) {
      waitPromise = axios(options);
    } else {
      waitPromise = Request(options);
    }
    waitPromise.then(res => {
      this.voting = false
      res = res.data
      if (res.status == 0) {
        const { list = [], can_vote, status } = res.data || {}
        // can_vote: 1 可投；0 不可投
        // status: 0 正常可投；1 还未开始；2已经结束
        optionList && optionList.forEach((option, index) => {
          let cnt = 0
          let has_vote = 0
          list.forEach((item) => {
            const { vote_id = '' } = item
            if (index == vote_id) {
              cnt = item.cnt
              has_vote = item.has_vote
              //has_vote: 1已投；0未投
            }
          })
          option.cnt = cnt
          option.has_vote = has_vote
        })
        // alert('optionList' + JSON.stringify(optionList))
        this.setState({ visible: true, can_vote, vote_status: status, optionList })
      }
    })
  }
  setLocalStorage = (value, vote_id) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        props: this.props,
      })
      return
    }
    utils.uploadTrack(this.props);

    if (this.voting) {
      return
    }
    const { contentConfig = {} } = this.props.config;
    const { imgType = {} } = contentConfig || {}
    const { type, nums } = imgType || {}
    this.voting = true
    const time = this.dealTime() || {}
    const { start_ts, end_ts } = time
    const options = {
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote/v1?access_token=znSnA7pxO35wtPBaur',
      method: 'post',
      withCredentials: true,
      data: {
        special_id: this.pageId,
        vote_id,
        vote_name: this.props.customAttributes["data-component-id"],
        vote_type: type == '按活动总周期' ? 1 : 2,
        limit: nums,
        start_ts, 
        end_ts
      },
    }
    let waitPromise = null;
    if (utils.isAndroid()) {
      waitPromise = axios(options);
    } else {
      waitPromise = Request(options);
    }
    waitPromise.then(res => {
      if (res.data.status === 0) {
        // alert(JSON.stringify(value))
        window && window.Jockey.send("localstorage", { type: "set", data: { [voteStorageName]: JSON.stringify(value) } });
        this.getLocalStorage()
      } else {
        this.voting = false
        window && window.Jockey.send('toast', {
          text: res.data.msg
        });
      }
    })
  }
  renderImgTypeView() {
    const { visible, vote_status, optionList = [] } = this.state
    if (!visible) {
      return null
    }
    const { vote_list = [] } = this.curVoteData || {}
    const backgroundColor = this.props.backgroundColor
    const { baseConfig, contentConfig } = this.props.config;
    const { moduleMarginTop, moduleMarginHorizon } = baseConfig || {}
    const { imgType = {}, question } = contentConfig || {}
    const { initShow, textColor, cardBgColor, btnBGColor, btnTextColor, type, nums } = imgType || {}
    let showVoteNum = true;//显示票数
    let btnStatus = this.state.can_vote;//1 所有都可以点击，0投票已达到上限(所有按钮置灰)
    const time = this.dealTime() || {}
    const afterTime = vote_status == 2 || (time && time.can_vote == 3);//本机时间是否超出活动结束时间
    // 转为数字处理，后续参与计算
    
    if (type == '按活动总周期') {
      let total = 0
      vote_list && vote_list.map(item => {
        total += item.nums
      })
      if (total >= nums && btnStatus == 1) {
        btnStatus = 0
      }
      if (initShow == '不显示' && total == 0) {
        showVoteNum = afterTime
      }
    } else if (type == '按日') {
      let curTotal = 0
      let total = 0
      if(vote_list){
        for (let i = 0; i < vote_list.length; i++) {
          if (vote_list[i].date == curDate) {
            curTotal = vote_list[i].nums
          }
          total += vote_list[i].nums
        }
      }
      if (curTotal >= nums && btnStatus == 1) {
        btnStatus = 0
      }
      if (initShow == '不显示' && total == 0) {
        showVoteNum = afterTime
      }
    }
    // if (initShow == '不显示' && (!vote_list || vote_list.length == 0)) {
    //   showVoteNum = false
    // }
    const showCenter = !showVoteNum || afterTime
    
    return <div
      className="pipeline-vote"
      {...this.props['customAttributes']}
      style={{
        paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
        marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0
      }}>
      {question && <div className="question" style={{ color: textColor }}>{question}</div>}
      <div className="option-list2">
        {optionList && optionList.map((item, index) => {
          const { img, updateNum, has_vote, cnt = 0 } = item
          let num = (cnt || 0) * 1;
          if (updateNum && updateNum * 1 != 0) {
            num += updateNum
          }
          if(num < 0){
            num = 0
          }
          let imgScale = 1 //宽高比
          const len = (img.split('_') || []).length
          const imgItem = len > 0 ? img.split('_')[len - 1].split('.')[0].split('x') : [];
          if(imgItem && imgItem.length == 2){
            const w = imgItem[0]
            const h = imgItem[1]
            if(w && h){
              imgScale = w/h
            }
          }
          const imgWidth = Math.floor((bodyWidth - 9 - moduleMarginHorizon * 2) / 2);
          const imgHeight = imgWidth / imgScale
          let hasVoteStatus = has_vote || 0;//当前选项是否已投票:0-未投；1-已投
          if (type == '按活动总周期' && vote_list && hasVoteStatus == 0) {
            for (let i = 0; i < vote_list.length; i++) {
              if (vote_list[i].vote_id.indexOf(index) != -1) {
                hasVoteStatus = 1
                break;
              }
            }
          } else if (type == '按日' && vote_list && hasVoteStatus == 0) {
            for (let i = 0; i < vote_list.length; i++) {
              if (vote_list[i].date == curDate && vote_list[i].vote_id.indexOf(index) != -1) {
                hasVoteStatus = 1
                break;
              }
            }
          }

          return <div className="option-item" key={index} style={{ backgroundColor: cardBgColor || backgroundColor, marginRight: (index % 2) == 0 ? '9px' : 0, width: imgWidth + 'px' }}>
            <img className="img" src={img} style={{ height: imgHeight + 'px' }} />
            <div className={`bottom-container ${showCenter ? (showVoteNum ? 'div4': 'div1') : (!afterTime && hasVoteStatus == 0 ? 'div2' : 'div3')}`}>
              {showVoteNum && <div className="num" style={{ color: textColor || '#FFF' }}>{num}票</div>}
              {afterTime ? null : hasVoteStatus == 0 ? <div className={`btn ${showCenter ? 'big' : 'small'} ${btnStatus == 0 ? 'selected' : ''}`} style={{ backgroundColor: btnBGColor, color: btnTextColor || backgroundColor, }} onClick={() => {
                if (btnStatus == 0) {
                  if(vote_status == 1){
                    window && window.Jockey.send('toast', {
                      text: '投票尚未开始，请耐心等待～'
                    });
                    return
                  }
                  if(vote_status == 2){
                    window && window.Jockey.send('toast', {
                      text: '投票已结束'
                    });
                    return
                  }
                  window && window.Jockey.send('toast', {
                    text: '投票次数已用完哦~'
                  });
                  return
                }
                let needAdd = true
                if (this.curVoteData && this.curVoteData.vote_list) {
                  for (let i = 0; i < this.curVoteData.vote_list.length; i++) {
                    if (this.curVoteData.vote_list[i].date == curDate) {
                      needAdd = false
                      this.curVoteData.vote_list[i].vote_id.push(index)
                      this.curVoteData.vote_list[i].nums = this.curVoteData.vote_list[i].nums + 1
                      break
                    }
                  }
                }
                if (needAdd) {
                  this.curVoteData = {
                    pageId: this.pageId,
                    vote_name: this.props.customAttributes["data-component-id"],
                    vote_list: [{
                      vote_id: [index],//对应日期的已投的id
                      date: curDate,//投票的日期
                      nums: 1,//对应日期的投票的总次数
                    }],
                  }
                }
                let isExit = false
                this.localVoteList && this.localVoteList.map((item, i) => {
                  if (item.pageId == this.pageId && item.vote_name == this.props.customAttributes["data-component-id"]) {
                    isExit = true
                    this.localVoteList[i] = this.curVoteData
                  }
                })
                if (!isExit) {
                  this.localVoteList.push(this.curVoteData)
                }
                this.setLocalStorage(this.localVoteList, index)
              }}>{vote_status == 1 ? '即将开始' : '投票'}</div> :
                <div className="voted">
                  {/* <img className="icon" src="https://static.shihuocdn.cn/admin/files/20231129/b62421ce453e4bfeadfb56526fc4ebad.png" style={{ backgroundColor: textColor || '#FFF' }}/> */}
                  <svg t="1701262809645" class="icon" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="4768" fill={textColor || '#FFF'}><path d="M122.709333 492.032a51.2 51.2 0 0 1 66.218667-2.133333l6.144 5.717333 197.205333 217.941333 424.533334-442.965333a51.2 51.2 0 0 1 65.877333-6.826667l6.485333 5.290667a51.2 51.2 0 0 1 6.826667 65.877333l-5.290667 6.485334L428.373333 824.149333a51.2 51.2 0 0 1-69.12 4.437334l-5.802666-5.461334-234.24-258.730666a51.2 51.2 0 0 1 3.584-72.362667z" p-id="4769"></path></svg>
                  <span className="text" style={{ color: textColor || '#FFF' }}>已投</span>
                </div>
              }
            </div>
          </div>
        })}
      </div>
    </div>
  }
  render() {

    const { visible } = this.state
    if (!visible) {
      return null
    }
    const { contentConfig } = this.props.config;
    // 转为数字处理，后续参与计算
    const isTextType = !contentConfig || contentConfig.showType == '文案形式'
    if (isTextType) return this.renderTextTypeView();
    return this.renderImgTypeView()
  }
}

PipelineImgList.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineImgList };
export default PipelineImgList;



// WEBPACK FOOTER //
// ./components/pipeline-vote/index.js